import { render, staticRenderFns } from "./WorkGroup.vue?vue&type=template&id=673ba640&scoped=true&"
import script from "./WorkGroup.vue?vue&type=script&lang=js&"
export * from "./WorkGroup.vue?vue&type=script&lang=js&"
import style0 from "./WorkGroup.vue?vue&type=style&index=0&id=673ba640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ba640",
  null
  
)

export default component.exports